import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getCertificatesForUser } from '../../services/firebaseCertificates';
import { awardBadge } from '../../services/firebaseBadges';
import CertificateView from '../../components/CertificateView/CertificateView';
import './Certificates.css';

export default function Certificates() {
  const { user } = useAuth();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    if (!user?.uid) {
      setCertificates([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    getCertificatesForUser(user.uid)
      .then((list) => {
        setCertificates(list);
        if (list.length >= 5) awardBadge(user.uid, 'five_courses').catch(() => {});
      })
      .catch(() => setCertificates([]))
      .finally(() => setLoading(false));
  }, [user?.uid]);

  const formatDate = (d) => {
    if (d?.toDate) return d.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    if (d) return new Date(d).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    return '—';
  };

  return (
    <div className="certificates-page">
      <div className="certificates-inner">
        <h1 className="certificates-title">My Certificates</h1>
        <p className="certificates-subtitle">Download or print your course completion certificates.</p>

        {loading ? (
          <p className="certificates-loading">Loading…</p>
        ) : certificates.length === 0 ? (
          <div className="certificates-empty">
            <p>You don’t have any certificates yet. Complete a course to 100% to earn one.</p>
            <Link to="/my-learning" className="certificates-link">My Learning</Link>
          </div>
        ) : (
          <div className="certificates-grid">
            {certificates.map((cert) => (
              <article key={cert.id} className="certificates-card">
                <div className="certificates-preview">
                  <div className="certificates-preview-inner">
                    <p className="certificates-preview-label">Certificate of Completion</p>
                    <h3 className="certificates-preview-course">{cert.courseTitle}</h3>
                    <p className="certificates-preview-date">Completed {formatDate(cert.completedAt)}</p>
                    <p className="certificates-preview-issuer"><span className="certificates-brand">Infobloom</span> · <span className="certificates-brand">LearnWithInfobloom</span></p>
                  </div>
                </div>
                <div className="certificates-actions">
                  <button type="button" className="certificates-btn certificates-btn-primary" onClick={() => setViewing(cert)}>
                    View / Download
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
      {viewing && (
        <CertificateView
          certificate={viewing}
          userName={user?.name}
          onClose={() => setViewing(null)}
        />
      )}
    </div>
  );
}
